exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recipeBox[data-v-4a32ce11]{height:70px;width:40vw;border:4px inset gray;border-radius:4px;padding:0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a32ce11","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/stockTransmutation/recipeElement.vue
// module id = 545
// module chunks = 0